// extracted by mini-css-extract-plugin
export default {"form":"invoice-purchase-order_form__RHxRU","number":"invoice-purchase-order_number__CdOnO","file":"invoice-purchase-order_file__6dq0D","error":"invoice-purchase-order_error__L3cgV"};